import React from 'react'
import moment from 'moment'

const CellDateTime = ({ attribute, data }) => {
    const value = data[attribute.name]
    return <>{value ? moment.utc(value).local().format('LLL') : '-'}</>
}

export default CellDateTime
